// removed by extract-text-webpack-plugin
module.exports = {"withPointer":"_2jX3eH6Gtcq7V_h0H2c_hL","modal":"SKU96WzY164-0vDI68sas","title":"_2BRTCwfgo3PvQTabO8Hkpf","contentWrapper":"_1r4QbnxCwxDmKdnAKjlOtw","content":"_1KDYnQ2AxNzab98CH5OioO","scrollContent":"_3KK3iD_IQMTlQ2JqHY3GKb","TabContainer":"dMm2RXO42Y8C1TGfPWXvX","Tab":"_33IXVY7GbFM2OFKNZQkBgh","active":"_3r05F3i28QiyFaD4USjWIT","TabContentContainer":"_3i-EY7GtpSnm3oBRqAHVaj","tabContent":"_238mH0R5RZGd6PdRAhAD_N","hidden":"_-bRHCHH6TX7Gl5rUYx1LT","buttons":"_2WIMtfSIjpK1-DtAyF1M7H","next":"_4PMOaPX1ucjMcRlDeF3HD"};


//////////////////
// WEBPACK FOOTER
// ./components/office/modalDialog.scss
// module id = 722
// module chunks = 0